export default __webpack_public_path__ + "static/media/cert-senior-manager-consumer-sc.72405cc3.jpg";